import { useEffect, useState } from "react";
import {
  BackSvgPPP,
  BedIconSvgPPP,
  CalendarIconSvgPPP,
  CruiseIconSvgPPP,
  GuestsIconSvgPPP,
  NightIconSvgPPP,
  OneWayTripIconSvgPPP,
  RoundTripIconSvgPPP,
  ShipIconSvgPPP,
} from "../svgImages";
import "./style.scss";

interface ITripDetailsCard {
  itineraryDetails: any;
  portSequence: any[];
  roomsData: any[];
};

const splitDate = (dateString: string) => {
  return (dateString?.split('T')?.[0] || 'NA');
};

const TripDetailsCard: React.FC<ITripDetailsCard> = ({ itineraryDetails, portSequence, roomsData }) => {
  const [trigger, setTrigger] = useState<boolean>(true);
  const [colCount, setColCount] = useState<number>(2);
  const [lastRowItems, setLastRowItems] = useState<number>(0);

  const handleTripType = (tripType: string) => {
    return tripType?.includes("one") ? "One Way Trip" : "Round Trip";
  };

  const totalGuests = roomsData?.reduce((total, room) => {
    const adults = room?.guests?.adults || 0;
    const children = room?.guests?.children || 0;
    const infants = room?.guests?.infants || 0;
    return total + adults + children + infants;
  }, 0);

  useEffect(() => { 
    const innerWidth = window.innerWidth;
    if (innerWidth >= 1445) {
      setColCount(5);
      setLastRowItems(portSequence?.length % 5);
    }
    else if ((innerWidth >= 1195 && innerWidth <= 1444) || (innerWidth >= 716 && innerWidth <= 768)) {
      setColCount(4);
      setLastRowItems(portSequence?.length % 4);
    }
    else if ((innerWidth >= 945 && innerWidth <= 1194) || (innerWidth >= 565 && innerWidth <= 716)) {
      setColCount(3);
      setLastRowItems(portSequence?.length % 3);
    }
    else if (innerWidth >= 416 && innerWidth <= 564) {
      setColCount(2);
      setLastRowItems(portSequence?.length % 2);
    }
    else {
      setColCount(1);
      setLastRowItems(portSequence?.length % 1);
    }
   }, [portSequence])

  return (
    <div className="trip-details-card-wrapper">
      <div className="vertical-text-wrapper">
        <span>TRIP DETAILS</span>
      </div>
      <div className="trip-details-card-body-wrapper">
        <span className="trip-details-card-body-name">{itineraryDetails?.route}</span>
        <div className="trip-details-card-body-info-wrapper">
          <div className="trip-info">
            <CalendarIconSvgPPP />
            <span>
              {new Date(splitDate(itineraryDetails?.start_time)).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
              -{" "}
              {new Date(splitDate(itineraryDetails?.end_time)).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </span>
          </div>
          <div className="trip-info">
            {itineraryDetails?.trip_type?.includes("one") ? (
              <OneWayTripIconSvgPPP width={20} height={18} fill="#3a3a3a" />
            ) : (
              <RoundTripIconSvgPPP />
            )}
            <span>{handleTripType(itineraryDetails?.trip_type)}</span>
          </div>
          <div className="trip-info">
            <CruiseIconSvgPPP />
            <span className="cruise-name">{itineraryDetails?.ship_name?.toLowerCase()}</span>
          </div>
          <div className="trip-info">
            <NightIconSvgPPP />
            <span>{itineraryDetails?.night_count} Nights</span>
          </div>
          <div className="trip-info">
            <BedIconSvgPPP />
            <span>
              {roomsData?.length} {`${roomsData?.length > 1 ? "Cabins" : "Cabin"}`}
            </span>
          </div>
          <div className="trip-info">
            <GuestsIconSvgPPP />
            <span>{totalGuests} {totalGuests > 1 ? 'Guests' : 'Guest'}</span>
          </div>
        </div>
        {trigger && (
          <div className={`trip-details-card-body-schedule-wrapper col-count-${portSequence.length < colCount ? portSequence.length : colCount} no-bb-${portSequence.length < colCount ? 0 : lastRowItems}`}>
            {portSequence?.map((port, index) => {
              return (
                <div className={"schedule-info"}>
                  {index === 0 && <span className="day-info">Departure: Day 01</span>}
                  {index !== 0 && index !== portSequence.length - 1 && (
                    <span className="day-info">Day {`${index + 1}`.padStart(2, '0')}</span>
                  )}
                  {index === portSequence.length - 1 && <span className="day-info">Arrival: Day {`${index + 1}`.padStart(2, '0')}</span>}
                  <span className="place-info">{port?.name}</span>
                  {index === 0 ? <span className="date-info">
                    {new Date(splitDate(port?.departure_time)).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }).toString()}
                  </span> : <span className="date-info">
                    {port?.arrival_time ? new Date(splitDate(port?.arrival_time)).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }).toString() : " "}
                  </span>
                  }
                  {index === 0 ? <span className="time-info">
                  {new Date(port?.departure_time).toLocaleTimeString("en-US", {
                     hour: "numeric",
                     minute: "numeric",
                     hour12: true,
                    })}
                  </span> : <span className="time-info">
                    {port?.arrival_time ? new Date(port?.arrival_time).toLocaleTimeString("en-US", {
                     hour: "numeric",
                     minute: "numeric",
                     hour12: true,
                    }) : " "}
                  </span>
                  }
                </div>
              );
            })}
          </div>
        )}
        <div className="view-button-wrapper">
          <ShipIconSvgPPP />
          <div onClick={() => setTrigger((prev) => !prev)}>
            <span>View {trigger ? "Less" : "More"}</span>
            <span className={`${trigger ? "open" : "close"}`}>
              <BackSvgPPP height={12} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripDetailsCard;
